import React, { useEffect, useState } from 'react'

import { Button, Col, DatePicker, Row, Select, Typography } from 'antd'
import moment from 'moment'

import CustomSelect from '../../../../components/CustomSelect/customSelect'
import { api, request } from '../../../../util/handlerRequestUtil'
import { getMessage } from '../../../../util/IntlMessages'
import { orderObjects } from '../../../../util/orderObjects'

const { RangePicker } = DatePicker
const { Option } = Select

const DATE_FORMAT = 'DD-MM-YYYY'

const FarmerPortalDashboardFilter = ({
  values,
  setFieldValueWithState,
  handleClickFilter,
  handleClickClearFilter,
  setFieldValueWithFields
}) => {
  const [dataPickerSelected, setDataPickerSelected] = useState(false)
  const [timeOptions, setTimeOptions] = useState([])

  const [formattedMacroRegions, setFormattedMacroRegions] = useState([])
  const [formattedMicroRegions, setFormattedMicroRegions] = useState([])

  const [formattedStates, setFormattedStates] = useState([])
  const [formattedCities, setFormattedCities] = useState([])

  const [formattedMaterialsI2x, setFormattedMaterialsI2x] = useState([])
  const [formattedMaterialsCheck, setFormattedMaterialsCheck] = useState([])

  const [enableMicroRegion, setEnableMicroRegion] = useState(false)
  const [enableState, setEnableState] = useState(false)
  const [enableCountie, setEnableCountie] = useState(false)

  // Form configuration
  const [formValues, setFormValues] = useState({})

  useEffect(() => {
    listMacroRegions()
    listReferencePeriods()
    listMaterials({ ignorePagination: true })
  }, [])

  async function listMacroRegions() {
    try {
      const response = await request(api.listMacroRegions())
      const formattedData = response.map((item) => ({
        value: item.macro_region,
        description: item.macro_region
      }))

      setFormattedMacroRegions(formattedData)
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  async function listMicroRegions(params) {
    try {
      const response = await request(api.listMicroRegions(params))

      const formattedData = response.map((item) => ({
        value: item.micro_region,
        description: item.micro_region
      }))

      setFormattedMicroRegions(formattedData)
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  async function listStates(params) {
    try {
      const response = await request(api.listStates(params))

      const formattedData = response.items.map((item) => ({
        value: item.stateAbbreviation,
        description: `${item.stateName} - ${item.stateAbbreviation}`
      }))

      formattedData.sort(orderObjects('description'))

      setFormattedStates(formattedData)
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  async function onChangeMacroRegion(value) {
    if (formValues.macroRegion !== value) {
      const newFormatedData = {
        ...formValues,
        macroRegion: value
      }

      await listMicroRegions({ macroRegion: value })

      setFormValues(newFormatedData)
      setEnableMicroRegion(true)
    }
  }

  async function onChangeMicroRegion(value) {
    if (formValues.microRegion !== value) {
      const newFormatedData = {
        ...formValues,
        microRegion: value
      }

      const { macroRegion, microRegion } = newFormatedData

      await listStates({ ignorePagination: true, macroRegion, microRegion })

      setFormValues(newFormatedData)
      setEnableState(true)
    }
  }

  async function onChangeState(value) {
    if (formValues.state !== value) {
      const newFormatedData = {
        ...formValues,
        state: value,
        city: getMessage('select')
      }

      const { macroRegion, microRegion } = newFormatedData

      await listCities({
        ignorePagination: true,
        stateAbbreviation: value,
        macroRegion,
        microRegion
      })

      setFormValues(newFormatedData)
      setEnableCountie(true)
    }
  }

  async function listCities(params) {
    try {
      const response = await request(api.listCities(params))

      const formattedData = []
      response.items.map((item) => {
        return formattedData.push({
          value: item.cityCode,
          id: item.id,
          description: item.cityName
        })
      })

      formattedData.sort(orderObjects('description'))

      setFormattedCities(formattedData)
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  async function listReferencePeriods() {
    let { items = [] } = await request(
      api.listReferencePeriod({
        include: 'referencePeriodRanges',
        active: true
      })
    )

    items = items.filter(({ referencePeriodRanges }) => referencePeriodRanges && referencePeriodRanges.length)

    const formattedValues = items.map((item) => ({
      value: item.periodName,
      description: item.periodName,
      initialDate:
        item.referencePeriodRanges[0] !== undefined
          ? moment(item.referencePeriodRanges[0].beginDate, 'YYYY-MM-DD').format('DD-MM-YYYY')
          : '',
      endDate:
        item.referencePeriodRanges[0] !== undefined
          ? moment(item.referencePeriodRanges[0].endDate, 'YYYY-MM-DD').format('DD-MM-YYYY')
          : ''
    }))

    setTimeOptions([...formattedValues, { value: 1, description: 1 }])
  }

  const formatMaterials = (material) => {
    const formattedData = material.map((item) => ({
      id: item.id,
      value: item.name,
      description: item.name
    }))

    return formattedData
  }

  async function listMaterials(params) {
    try {
      const { items } = await request(api.getMaterials(params))

      const i2x = []
      const check = []

      items.forEach((item) => {
        if (['I2X', 'XTEND'].includes(item.technology.toUpperCase())) {
          i2x.push(item)
        } else {
          check.push(item)
        }
      })

      const i2xFormatted = formatMaterials(i2x)
      const checkFormatted = formatMaterials(check)

      setFormattedMaterialsI2x(i2xFormatted)
      setFormattedMaterialsCheck(checkFormatted)
    } catch (error_) {
      console.tron.log(error_)
    }
  }

  function onChangePeriod(values, interval) {
    const periods = []

    if (values.includes(1)) {
      return (
        interval &&
        setFieldValueWithFields({
          periods: [
            {
              initialDate: interval[0],
              endDate: interval[1]
            }
          ]
        })
      )
    }

    timeOptions.forEach(({ value, initialDate, endDate }) => {
      if (values.includes(value)) {
        periods.push({ initialDate, endDate })
      }
    })

    if (values.length) {
      setTimeOptions(timeOptions.filter((obj) => obj.description !== 1))
    } else {
      setTimeOptions([...timeOptions, { value: 1, description: 1 }])
    }

    setFieldValueWithFields({ periods })
  }

  function renderPeriodFilter({ span = 6 }) {
    return (
      <Col span={span}>
        <Typography>{getMessage('timeCourse')}</Typography>
        {dataPickerSelected ? (
          <div style={{ display: 'flex' }}>
            <RangePicker
              separator={'-'}
              placeholder={['Data Inicial', 'Data Final']}
              style={{
                marginTop: 8,
                border: '0px solid none',
                backgroundColor: 'transparent'
              }}
              format={DATE_FORMAT}
              onChange={(e, values) => {
                onChangePeriod([1], values)
              }}
            />
            <Button
              icon="close"
              type="ghost"
              style={{
                marginTop: 8,
                width: 30,
                marginLeft: 5
              }}
              onClick={() => setDataPickerSelected(false)}
            />
          </div>
        ) : (
          <Select
            placeholder={getMessage('select')}
            mode="multiple"
            onChange={(value) => {
              if (value !== 1) {
                onChangePeriod(value)
              } else {
                setDataPickerSelected(false)
              }
            }}
            style={{ width: '100%', marginTop: 7 }}
          >
            {timeOptions.map((status) =>
              status.description !== 1 ? (
                <Option value={status.value} key={status.value}>
                  {status.description}
                </Option>
              ) : (
                <Option
                  value={status.value}
                  key={status.value}
                  onClick={() => setDataPickerSelected(!dataPickerSelected)}
                >
                  Personalizado
                </Option>
              )
            )}
          </Select>
        )}
      </Col>
    )
  }

  function renderFormFilters() {
    return (
      <>
        <CustomSelect
          showSearch
          field="macroRegionFilter"
          label={getMessage('macroRegion')}
          setFieldValue={setFieldValueWithState}
          rowSpan={6}
          value={values}
          onChange={onChangeMacroRegion}
          values={formattedMacroRegions}
        />
        <CustomSelect
          showSearch
          enable={Boolean(!enableMicroRegion)}
          field="microRegionFilter"
          label={getMessage('microRegion')}
          setFieldValue={setFieldValueWithState}
          rowSpan={6}
          value={values}
          onChange={onChangeMicroRegion}
          values={formattedMicroRegions}
        />
        <CustomSelect
          showSearch
          enable={Boolean(!enableState)}
          field="stateFilter"
          label={getMessage('state')}
          setFieldValue={setFieldValueWithState}
          rowSpan={6}
          value={values}
          onChange={onChangeState}
          values={formattedStates}
        />
        <CustomSelect
          showSearch
          enable={Boolean(!enableCountie)}
          field="countiesFilter"
          label={getMessage('countie')}
          setFieldValue={setFieldValueWithState}
          rowSpan={6}
          value={values}
          values={formattedCities}
        />
        {renderPeriodFilter({ span: 6 })}
        <CustomSelect
          showSearch
          field="materialsI2xFilter"
          label={getMessage('materialsI2x')}
          multiple
          setFieldValue={setFieldValueWithState}
          rowSpan={6}
          value={values}
          values={formattedMaterialsI2x}
        />
        <CustomSelect
          showSearch
          field="materialsCheckFilter"
          label={getMessage('materialsCheck')}
          multiple
          setFieldValue={setFieldValueWithState}
          rowSpan={6}
          value={values}
          values={formattedMaterialsCheck}
        />
      </>
    )
  }

  return (
    <>
      <Row type="flex" justify="start">
        {renderFormFilters()}
      </Row>
      <div className="horizontal-line" style={{ margin: '20px 0px 20px' }}></div>
      <Row type="flex" justify="end">
        <Col span={5}>
          <Button
            icon="search"
            className="bgPrimary"
            style={{ width: '100%' }}
            type="dashed"
            onClick={handleClickFilter}
          >
            {getMessage('search')}
          </Button>
        </Col>
        <Col span={5}>
          <Button
            icon="close"
            style={{
              width: '100%',
              borderColor: '#EE778F',
              color: '#EE778F'
            }}
            type="ghost"
            onClick={handleClickClearFilter}
          >
            {getMessage('cleanFilters')}
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default FarmerPortalDashboardFilter
